import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { getUser, setSubsite, getSubsite } from '../../reducers/auth';
import { getMenu } from '../../reducers/menu';
import { useNavigate } from "react-router-dom";
import SubsiteService from "../../services/subsite.service";

const SwitchSiteModal = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector(getUser);
  const  currentSite  = useSelector(getSubsite);
  const { isSubmitting } = useState(false);
  const [ selectedSite, setSelectedSite ] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(selectedSite != null) {
      for(var i=0; i<currentUser.subsites.length; i++) {
        if(selectedSite === currentUser.subsites[i].abbreviation) {
          let newSubsite = await SubsiteService.setSubsite(currentUser.subsites[i]);
          dispatch(getMenu(currentSite.id));
          dispatch(setSubsite(currentUser.subsites[i]));
          navigate(props.redirect);
          break;
        }
      }
    }
    window.location.reload(false);
    props.closeModal(false);
  }

  const handleChange = (e) => {
    setSelectedSite(e.target.value);
  }

  const modalClose = () => {
    props.closeModal(false);
  }
    // Schema for yup

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Choose Site<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
            <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3" controlId="state">
                <Form.Label>Sites you belong to:</Form.Label>
                <Form.Select
                  name="site"
                  onChange={handleChange}
                  >
                    {currentUser && currentUser.subsites && currentUser.subsites.map((subsite) => {
                        var selected = false;
                        if(currentSite.abbreviation === subsite.abbreviation) {
                          selected = true;
                        }
                        return (
                            <option key={"subsite_" + subsite.id}
                              value={subsite.abbreviation}
                              selected={selected}
                              >
                              {subsite.subsiteName}
                              </option>
                        );
                    })}
                </Form.Select>
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Change Site
                </Button>
              </Modal.Footer>
            </Form>  
    </Modal.Body>
    </Modal>
  );
};

export default SwitchSiteModal; 